module.exports = "https://cdn.betha.cloud/base/g4/design/3.13.2/assets/images/b30-sem-resultado.png";